<div class="container">
    <div class="section-title">
        <!-- Espacio reservado para título principal -->
    </div>
    <div class="row">
        <div class="col-lg-3 col-sm-6 col-md-6">
            <div class="single-features-box">
                <div class="icon">
                    <i class="fas fa-medal" style="color: #124e91;"></i>
                </div>
                <h3>Beneficios</h3>
                <p>Gestione y configure los beneficios disponibles para afiliados.</p>
                <a href="#/tramites-configuracion" class="link-btn">Administrar</a>
            </div>
        </div>

        <div class="col-lg-3 col-sm-6 col-md-6">
            <div class="single-features-box">
                <div class="icon">
                    <i class="fas fa-newspaper" style="color: #124e91;"></i>
                </div>
                <h3>Noticias</h3>
                <p>Gestión de contenido informativo</p>
                <a (click)="toggleNoticias()" class="link-btn">Gestionar</a>
                <div class="dropdown-options" *ngIf="showNoticias">
                    <a routerLink="/listado-noticia" class="btn btn-primary">Listado de Noticias</a>
                    <a routerLink="/alta-noticia" class="btn btn-success">Nueva Noticia</a>
                </div>
            </div>
        </div>

        <div class="col-lg-3 col-sm-6 col-md-6">
            <div class="single-features-box">
                <div class="icon">
                    <i class="fas fa-building" style="color: #124e91;"></i>
                </div>
                <h3>Sedes</h3>
                <p>Administración de ubicaciones.</p>
                <a href="#/sedes-listado" class="link-btn">Configurar</a>
            </div>
        </div>

        <div class="col-lg-3 col-sm-6 col-md-6">
            <div class="single-features-box">
                <div class="icon">
                    <i class="far fa-address-card" style="color: #124e91;"></i>
                </div>
                <h3>Afiliados</h3>
                <p>Control central de registros y estados de afiliación.</p>
                <a href="#/afiliados-listado" class="link-btn">Supervisar</a>
            </div>
        </div>

        <div class="col-lg-3 col-sm-6 col-md-6">
            <div class="single-features-box">
                <div class="icon">
                    <i class="fas fa-user-check" style="color: #124e91;"></i>
                </div>
                <h3>Autorizaciones</h3>
                <p>Control de permisos y aprobaciones de acceso al sistema.</p>
                <a href="#/autorizaciones-listado" class="link-btn">Revisar</a>
            </div>
        </div>

        <div class="col-lg-3 col-sm-6 col-md-6">
            <div class="single-features-box">
                <div class="icon">
                    <i class="fas fa-users" style="color: #124e91;"></i>
                </div>
                <h3>Usuarios</h3>
                <p>Administración de cuentas y roles de administradores.</p>
                <a href="#/usuarios-administracion" class="link-btn">Administrar</a>
            </div>
        </div>

        <div class="col-lg-3 col-sm-6 col-md-6">
            <div class="single-features-box">
                <div class="icon">
                    <i class="fas fa-calendar-alt" style="color: #124e91;"></i>
                </div>
                <h3>Calendario</h3>
                <p>Configuración de eventos en el calendario.</p>
                <a href="#/configuracion-calendario" class="link-btn">Configurar</a>
            </div>
        </div>

        <div class="col-lg-3 col-sm-6 col-md-6">
            <div class="single-features-box">
                <div class="icon">
                    <i class="fas fa-paper-plane" style="color: #124e91;"></i>
                </div>
                <h3>Mensajes Push</h3>
                <p>Envío de notificaciones push a dispositivos.</p>
                <a href="#/push-administracion" class="link-btn">Enviar</a>
            </div>
        </div>

        <div class="col-lg-3 col-sm-6 col-md-6">
            <div class="single-features-box">
                <div class="icon">
                    <i class="fas fa-file-signature" style="color: #124e91;"></i>
                </div>
                <h3>Inscripciones</h3>
                <p>Bandeja de inscripciones de afiliados.</p>
                <a href="#/listado-inscripciones" class="link-btn">Ver bandeja</a>
            </div>
        </div>
    </div>
</div>